import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Restaurant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render() {
    const faqs = [
      { q: "❓ Это действительно бесплатно для моего ресторана?", a: "Да. Никакой абонентской платы, процентов с броней. Оплата только за SMS и эквайринг (при подключении онлайн-оплаты). Бесплатно навсегда." },
      { q: "❓ Могу ли я вносить бронирования вручную, если гости звонят?", a: "Да. Администратор добавляет бронь в календарь за 10 секунд, заполняет имя, телефон, особые пожелания. Система сама отправит напоминание." },
      { q: "❓ Как гости увидят схему зала?", a: "После выбора даты и времени откроется план зала со свободными столиками. Гости нажимают на понравившийся и подтверждают бронь." },
      { q: "❓ Можно ли настроить разные цены для зон?", a: "Да. Для каждого столика или зоны (VIP, у окна, терраса) можно задать свою цену или минимальную сумму заказа. Гости видят цену при выборе." },
      { q: "❓ Как работает подписка на освобождение столика?", a: "Гость выбирает занятое время и оставляет контакт. Когда бронь освобождается (отмена или перенос), система сразу уведомляет его. Гость успевает забронировать первым." }
    ];

    return (
      <div>
        <Helmet>
          <title>Бронирование столиков в ресторане | Система для кафе — Planna</title>
          <meta name="description" content="Визуальная схема зала с выбором конкретного столика. Гости бронируют сами, вы видите загрузку в реальном времени. Бесплатно для ресторанов и кафе." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>

        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">🍽️ Для ресторанов, кафе, баров | Бесплатно навсегда</div>
            <h1>Управляйте бронированием столиков <span className="highlight">визуально и без хлопот</span></h1>
            <p className="hero-description">Схема зала, выбор столика гостями, приём заявок по телефону и онлайн. Автоматические напоминания, аналитика загрузки и умные инструменты. Всё бесплатно.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключить ресторан бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Преимущества (сетка) */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Всё для управления залом</h2>
              <p className="section-subtitle">Принимайте бронирования любым способом и заполняйте зал на 100%</p>
            </div>
            <div className="grid-3 fade-up">
              <div className="benefit-card"><i className="fas fa-chair benefit-icon"></i><h3>Схема зала и выбор столика</h3><p>Гости видят план зала и сами выбирают столик (у окна, сцены, бара). Вы управляете доступностью.</p></div>
              <div className="benefit-card"><i className="fas fa-phone-alt benefit-icon"></i><h3>Брони по телефону — тоже в системе</h3><p>Администратор вносит заявки вручную одним кликом. Всё в едином календаре.</p></div>
              <div className="benefit-card"><i className="fas fa-bell benefit-icon"></i><h3>Автоматические напоминания</h3><p>SMS, Telegram, push — гости не забывают о брони, снижение неявок на 70%.</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>Аналитика загрузки зала</h3><p>Пиковые часы, популярные зоны, занятость столов — полный контроль.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>QR-код для гостей</h3><p>Разместите на входе, меню или в соцсетях — бронирование в один клик.</p></div>
              <div className="benefit-card"><i className="fas fa-hand-holding-usd benefit-icon"></i><h3>Дополнительные услуги и предоплата</h3><p>Гости могут выбрать депозит, отметить особые пожелания — увеличивайте средний чек.</p></div>
            </div>
          </div>
        </section>

        {/* Скриншоты (замените src на свои) */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Как это выглядит на деле</h2>
              <p className="section-subtitle">Интуитивно понятный интерфейс для вашего персонала и гостей</p>
            </div>
            <div className="grid-2 fade-up" style={{ gap: '2.5rem' }}>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Схема+зала+с+выбором+столика" alt="Схема зала" />
                <div className="mockup-label">🗺️ Визуальная схема зала</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Календарь+броней+ресторана" alt="Календарь броней" />
                <div className="mockup-label">📅 Единый календарь броней</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=QR-код+ресторана" alt="QR-код" />
                <div className="mockup-label">📱 QR-код для записи гостей</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="https://placehold.co/600x400/EEF2FF/3B82F6?text=Напоминание+гостю" alt="Напоминание" />
                <div className="mockup-label">🔔 Напоминание в Telegram/SMS</div>
              </div>
            </div>
          </div>
        </section>

        {/* Умные функции */}
        <section>
          <div className="container">
            {/* Подписка на освободившиеся столики */}
            <div className="smart-block fade-up" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem', marginTop: 0 }}>
              <div style={{ flex: 1 }}>
                <i className="fas fa-bell" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Подписка на освободившиеся столики</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Если все столики в желаемое время заняты, гость может <strong>подписаться на освобождение</strong>. Как только кто-то отменит бронь — мгновенное уведомление в Telegram, SMS или push. Гость занимает столик первым.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Ни одного потерянного гостя</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Автоматическое заполнение «окон»</li>
                </ul>
              </div>
              <div style={{ flex: 1 }}>
                <div className="screenshot-placeholder">
                  <img src="https://placehold.co/500x300/F9FAFB/32bea6?text=Подписка+на+столик" alt="Подписка на столик" />
                  <div className="mockup-label">🔔 Уведомление об освобождении</div>
                </div>
              </div>
            </div>

            {/* Календарь загрузки зала на месяц */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-chart-line" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Календарь загрузки зала на месяц</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Гость видит цветовую индикацию загрузки на каждый день. Зелёные дни — свободно, жёлтые — средняя загрузка, красные — пик. Легко выбрать спокойный вечер для ужина.</p>
                  <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Равномерное распределение гостей</li>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Повышение лояльности — гости ценят выбор</li>
                  </ul>
                </div>
                <div style={{ flex: '0.9' }}>
                  <div className="screenshot-placeholder">
                    <img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Календарь+загрузки+месяца" alt="Календарь загрузки" />
                    <div className="mockup-label">📅 Цветовая индикация загрузки</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Выбор по длительности свободного слота */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-clock" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Выберите свободное время под ваш график</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Гость может отфильтровать доступные столики по длительности бронирования. Например, найти окно ровно на 1 час для бизнес-ланча или на 2,5 часа для ужина.</p>
                  <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобно для гостей</li>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Оптимальное использование времени зала</li>
                  </ul>
                </div>
                <div style={{ flex: '0.9' }}>
                  <div className="screenshot-placeholder">
                    <img src="https://placehold.co/450x280/F9FAFB/32bea6?text=Фильтр+по+длительности" alt="Фильтр по длительности" />
                    <div className="mockup-label">⏱️ Поиск по длительности слота</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Два календаря при бронировании (без записи) */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
                <div style={{ flex: 1 }}>
                  <div className="screenshot-placeholder">
                    <img src="{{mainApiUrl}}combined1.png" alt="Два календаря" />
                    <div className="mockup-label">📅 Два календаря – один выбор</div>
                  </div>
                </div>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>При бронировании — два календаря рядом</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Система показывает гостю одновременно его личные события (из Google, Apple, Яндекс.Календаря) и свободные столики ресторана. Гость сразу видит, когда он занят, и выбирает только время, которое подходит обоим. <strong>Никакой синхронизации и записи в календарь гостя не происходит</strong> — только чтение для удобства выбора.</p>
                  <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Гость не забывает о своих планах</li>
                    <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Исключены случайные накладки</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Для каких заведений */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Идеально для любого заведения</h2>
            <div className="stats-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-utensils"></i><h3>Ресторан</h3><p>Полный контроль загрузки</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-coffee"></i><h3>Кафе</h3><p>Быстрая запись столиков</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-wine-glass-alt"></i><h3>Бар / паб</h3><p>Бронирование зон у бара</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '160px' }}><i className="fas fa-calendar-alt"></i><h3>Банкетный зал</h3><p>Управление мероприятиями</p></div>
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
              <div style={{ flex: 1 }}>
                <div className="screenshot-placeholder">
                  <img src="{{mainApiUrl}}calendar1.png" alt="Мобильное приложение" />
                  <div className="mockup-label">📱 Управляйте рестораном со смартфона</div>
                </div>
              </div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Ваши сотрудники и гости могут пользоваться сервисом через удобные нативные приложения для iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для ресторана:</strong> принимайте бронирования, управляйте схемой зала, получайте уведомления — всё с телефона</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для гостей:</strong> бронирование в один клик, календарь, выбор столика</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Кроссплатформенность — работайте где угодно</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: '45px' }} /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png" alt="Google Play" style={{ height: '45px' }} /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Частые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>
                    {faq.q} <i className="fas fa-chevron-down"></i>
                  </div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Призыв к действию */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Начните управлять бронированием столиков уже сегодня</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Больше никаких путаниц и потерянных заявок. Ваш ресторан будет заполнен всегда.</p>
            <a href="/configcompany" className="btn-filled" style={{ background: 'white', color: '#1F2937', boxShadow: 'none' }}>Подключить ресторан бесплатно <i className="fas fa-arrow-right"></i></a>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>Настройка за 15 минут. QR-код, напоминания, аналитика — 0₽</p>
          </div>
        </section>
      </div>
    );
  }
}
